/**
 * A function which shows a given pointer style. Normally implemented as a
 * function which sets the CSS cursor style of a Root's canvas
 *
 * @category Core
 */
export type PointerStyleHandler = (newPointerStyle: string) => void;
